import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm, ValidatedBlobField } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IPart } from 'app/shared/model/part.model';
import { getEntities as getParts } from 'app/entities/part/part.reducer';
import { IMaintenanceVehicle } from 'app/shared/model/maintenance-vehicle.model';
import { getEntities as getMaintenanceVehicles } from 'app/entities/maintenance-vehicle/maintenance-vehicle.reducer';
import { getEntity, updateEntity, createEntity, reset } from './maintenance-part.reducer';
import { IMaintenancePart } from 'app/shared/model/maintenance-part.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MaintenancePartUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const parts = useAppSelector(state => state.part.entities);
  const maintenanceVehicles = useAppSelector(state => state.maintenanceVehicle.entities);
  const maintenancePartEntity = useAppSelector(state => state.maintenancePart.entity);
  const loading = useAppSelector(state => state.maintenancePart.loading);
  const updating = useAppSelector(state => state.maintenancePart.updating);
  const updateSuccess = useAppSelector(state => state.maintenancePart.updateSuccess);

  const handleClose = () => {
    props.history.push('/maintenance-part' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getParts({}));
    dispatch(getMaintenanceVehicles({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...maintenancePartEntity,
      ...values,
      part: parts.find(it => it.id.toString() === values.partId.toString()),
      maintenanceVehicle: maintenanceVehicles.find(it => it.id.toString() === values.maintenanceVehicleId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...maintenancePartEntity,
          partId: maintenancePartEntity?.part?.id,
          maintenanceVehicleId: maintenancePartEntity?.maintenanceVehicle?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.maintenancePart.home.createOrEditLabel" data-cy="MaintenancePartCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.maintenancePart.home.createOrEditLabel">Create or edit a MaintenancePart</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="maintenance-part-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedBlobField
                label={translate('fleetSenseApp.maintenancePart.proof')}
                id="maintenance-part-proof"
                name="proof"
                data-cy="proof"
                openActionLabel={translate('entity.action.open')}
              />
              <ValidatedField
                label={translate('fleetSenseApp.maintenancePart.objectKey')}
                id="maintenance-part-objectKey"
                name="objectKey"
                data-cy="objectKey"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.maintenancePart.description')}
                id="maintenance-part-description"
                name="description"
                data-cy="description"
                type="textarea"
              />
              <ValidatedField
                label={translate('fleetSenseApp.maintenancePart.km')}
                id="maintenance-part-km"
                name="km"
                data-cy="km"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.maintenancePart.age')}
                id="maintenance-part-age"
                name="age"
                data-cy="age"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.maintenancePart.hour')}
                id="maintenance-part-hour"
                name="hour"
                data-cy="hour"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.maintenancePart.replaced')}
                id="maintenance-part-replaced"
                name="replaced"
                data-cy="replaced"
                check
                type="checkbox"
              />
              <ValidatedField
                id="maintenance-part-part"
                name="partId"
                data-cy="part"
                label={translate('fleetSenseApp.maintenancePart.part')}
                type="select"
              >
                <option value="" key="0" />
                {parts
                  ? parts.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="maintenance-part-maintenanceVehicle"
                name="maintenanceVehicleId"
                data-cy="maintenanceVehicle"
                label={translate('fleetSenseApp.maintenancePart.maintenanceVehicle')}
                type="select"
              >
                <option value="" key="0" />
                {maintenanceVehicles
                  ? maintenanceVehicles.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.created}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/maintenance-part" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MaintenancePartUpdate;
